// import logo from "./logo.svg";
import "./App.css";

import "./assets/css/bootstrap.min.css"
// import "./assets/css/plugin.css"

import "./assets/css/default.css"

import "./assets/css/styles.css"


import "./assets/icons/font-awesome.min.css"













import Buy from "./Buy";
import Header from './Components/Header';
import Footer from './Components/Footer';
import Eventlists from "./TheEvents/Eventlists"
import BookTickets from "./OrderTickets/BookTickets";
import Tickettypes from "./Tickettypes/Tickettypes"
import TheEvent from "./TheEvents/TheEvents"
import Jonny_Sunday_Event from "./events/Jonny_Sunday_Event";
import Sunday_Event from "../src/events/sunday_event";
import Saturday_Event from "./events/saturday_event";
import Sat_Sun_Mon_Basket_Ball_Event from "./events/Sat_Sun_Mon_Basket_Ball_Event";
import Sat_Sun_Mon_Expo_Event from "./events/Sat_Sun_Mon_Expo_Event";
import Chapa from "./events/chapa_transation_history";
import Vip from "./events/vip"
import Certificate from "./Certificate";

import ProtectedRoute from "./ProtectedRoute.js";

//auth 
import NEWPASSWORD from "./Auth/NEWPASSWORD";
import OTPSIGNIN from "./Auth/OTP-SIGNIN"
import OTP from "./Auth/OTP"
import RESETPASSWORD from "./Auth/RESETPASSWORD"
import SIGNIN from "./Auth/SIGNIN"
import SIGNUP from "./Auth/SIGNUP"
import TERMSSERVICES from "./Auth/TERMSSERVICES"

import MobileBottomNav from "./Components/MobileBottomNav.jsx";
// profile 
import Profile from "./Profile/Profile.js";

import Checkout from "./Checkout/Checkout.js"
import MyOrders from "./MyOrders/Orders.js";

import OrderDetails from "./MyOrders/OrderDetails.js";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
if (process.env.NODE_ENV === "production") {
  console.log = () => { };
  console.debug = () => { };
  console.info = () => { };
  console.warn = () => { };
  console.error = () => { };
}
if (process.env.NODE_ENV === 'development') {
  // console.log = () => {};
  // console.debug = () => {};
  // console.info = () => {};
  // console.warn = () => {};
  // console.error = () => {};
}

function App() {
  return (
    <Router>
      <Header></Header>
      <MobileBottomNav></MobileBottomNav>
      <Routes>
        <Route path="/" element={<Eventlists />} />
 



        <Route path="/SIGNUP" element={
          <SIGNUP />} />
        <Route path="/NEWPASSWORD" element={<NEWPASSWORD />} />
        <Route path="/OTPSIGNIN" element={<OTPSIGNIN />} />
        <Route path="/OTP" element={<OTP />} />
        <Route path="/RESETPASSWORD" element={<RESETPASSWORD />} />
        <Route path="/SIGNIN" element={<SIGNIN />} />
        <Route path="/TERMSSERVICES" element={<TERMSSERVICES />} />
        <Route path="/Profile" element={

          <ProtectedRoute>

            <Profile />
          </ProtectedRoute>


        } />
        <Route path="/MyOrders" element={

          <ProtectedRoute>

            <MyOrders />
          </ProtectedRoute>



        } />
        <Route path="/OrderDetails" element={
          <ProtectedRoute>


            <OrderDetails />
          </ProtectedRoute>


        } />
















        <Route path="/Tickettypes/:id" element={<Tickettypes />} />
        <Route path="/Checkout" element={
          <ProtectedRoute>

            <Checkout />
          </ProtectedRoute>



        } />






        <Route path="/BookTickets" element={
          <ProtectedRoute>

            <BookTickets />
          </ProtectedRoute>

        } />
        <Route path="/Chapa" element={

          <ProtectedRoute>




            <Chapa />
          </ProtectedRoute>



        } />
        {/* <Route path="/Vip" element={<Vip />} />
        <Route path="/Jonny_Sunday_Event" element={<Jonny_Sunday_Event />} />
        <Route path="/Sunday_Event" element={<Sunday_Event />} />
        <Route path="/Saturday_Event" element={<Saturday_Event />} />
        <Route
          path="/Sat_Sun_Mon_Basket_Ball_Event"
          element={<Sat_Sun_Mon_Basket_Ball_Event />}
        />
        <Route
          path="/Sat_Sun_Mon_Expo_Event"
          element={<Sat_Sun_Mon_Expo_Event />}
        /> */}
        {/* <Route path="/Certificate" element={<Certificate />} /> */}
      </Routes>
      <Footer></Footer>
    </Router>
  );
}

export default App;
